import {gsap} from "gsap";
<template>
  <div class="facts">
    <div class="container">
      <div class="headline-wrapper">
        <headline kicker="Strategie" headline="Klar definiert: Unsere Unternehmensziele"/>
      </div>
      <div class="item-wrapper">
        <div class="items" ref="items">
          <profile-facts-item image="strategy-01.svg" text="Wir verdoppeln unser Ergebnis bis 2025." />
          <profile-facts-item image="strategy-02.svg" text="Wir stärken unsere Marktposition und gewinnen neue Kunden." />
          <profile-facts-item image="strategy-03.svg" text="Wir wachsen durch innovative und digitale Lösungen." />
          <profile-facts-item image="strategy-04.svg" text="Wir stellen die Strom- und Fernwärme&shy;erzeu&shy;gung auf erneuerbare Energien um." />
          <profile-facts-item image="strategy-05.svg" text="Wir entwickeln unsere Netze zukunftsfähig weiter." />
          <profile-facts-item image="strategy-06.svg" text="Digitalisierung ist der Motor für exzellente Prozesse und innovative Geschäftsmodelle." />
          <profile-facts-item image="strategy-07.svg" text="Schnelle Anpassungs&shy;fähigkeit ist die Basis für unseren Erfolg." />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Headline from "./Headline";
  import ProfileFactsItem from "./ProfileFactsItem";
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  gsap.registerPlugin(ScrollTrigger);

  export default {
    name: "ProfileFacts",
    components: {ProfileFactsItem, Headline},
    mounted() {
      const items = this.$refs.items;

      gsap.to(items,{
        x: items.offsetWidth - items.scrollWidth,
        scrollTrigger: {
          trigger: items,
          scrub: 0.2,
          scroller: '.content-wrapper',
          start: 'bottom 90%',
          end: 'top 10%'
        }
      });
    }
  }
</script>

<style scoped>
  .facts {
    overflow: hidden;
    margin: 5% 0 10%;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    max-width: calc(100% - 120px);
  }
  .headline-wrapper {
    margin-bottom: 5%;
    max-width: 420px;
  }
  .items {
    display: flex;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .container {
      max-width: calc(100% - 60px);
    }
  }
  @media(max-width: 999px) {
    .container {
      max-width: 100%;
    }
    .headline-wrapper {
      padding: 0 34px;
      max-width: 480px;
    }
    .items {
      transform: none !important;
      padding-left: 34px;
      overflow: auto;
    }
  }
  @media(max-width: 767px) {
    .items {
      padding-left: 20px;
    }
    .headline-wrapper {
      padding: 0 20px;
    }
  }
</style>